/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        17/02/2020      2560: 400 Bad Request Issue with gemtriageapi-qa3 POST GemTriage/UpdateTriageLogSymptoms
*********************************************************************************/
import { Link } from "@mna/react";
import PageTitle from "features/PageTitle";
import i18next from "i18next";
import { Trans } from "react-i18next";
import LoadingScreen from '../../../features/LoadingScreen'
import { checkAndGetSessionStorageValue, checkAndGetLocalStorageValue } from "../../../features/utils"

const confirmtitle = (
  <Trans i18nKey="findcareoption.confirm.confirm_title">
    Is this information correct?
  </Trans>
);

export default ({
  state: {
    triageRequest: {
      gender,
      birthdate,
      pregnant,
      selectChildBirth,
      isFemaleInPregnantStage,
      userName,
      travelDatesFrom,
      travelDatesTo,
      policyNumber,
      selectRecentPhysicalInjury,
      riskFactorVal
    },
  },
  actions,
  history,
  previousStepName,
  nextStepName,
  hasCurrentLocation,
  setState,
  state,
}) => {
  state.triageRequest.activeMenu = "start"
  return (
    <div className="standby-content standby-content-bottom-nav">
      <LoadingScreen isLoading={state.isLoading_ConfirmDetails}>
        <article className="standby-article">
          <div className="standby-center">
            <PageTitle titleText={confirmtitle} align="center" />
          </div>
          <div className="standby-input-info">
            <h2 className="fontWeight"><Trans i18nKey="findcareoption.confirm.confirm_subtitle">
              You are:
            </Trans></h2>
            <ul>
              {state.IsValidUser && userName && <li> {userName.trim()}</li>}
              {gender === "M" ? (
                <li><Trans i18nKey="findcareoption.Start.Birthgender">Sex assigned at birth?</Trans> - <Trans i18nKey="findcareoption.Start.Male">Male</Trans></li>
              ) : (
                <li>  <Trans i18nKey="findcareoption.Start.Birthgender">Sex assigned at birth?</Trans> - <Trans i18nKey="findcareoption.Start.Female">Female</Trans></li>
              )}

              <li>
                <Trans i18nKey="findcareoption.Start.DOB">What's your birthdate?</Trans> - {birthdate.day}{" "}
                {i18next.t("findcareoption.Start.Months." + birthdate.month)}{" "}
                {birthdate.year}
              </li>
              {riskFactorVal && (
                <li>
                  {riskFactorVal} -{" "}
                  {selectRecentPhysicalInjury === true ? (
                    <Trans i18nKey="findcareoption.Yes">Yes</Trans>
                  ) : (
                    <Trans i18nKey="findcareoption.No">No</Trans>
                  )}
                </li>
              )}
              {gender === "F" && isFemaleInPregnantStage && (
                <li>
                  <Trans i18nKey="findcareoption.Start.Pregnancystatus"> Are you currently pregnant?</Trans>{" "} -
                  {" "}{pregnant === true ? (
                    <Trans i18nKey="findcareoption.Yes">Yes</Trans>
                  ) : (
                    <Trans i18nKey="findcareoption.No">No</Trans>
                  )}
                </li>
              )}
              {gender === "F" && isFemaleInPregnantStage && (
                <li>
                  <Trans i18nKey="findcareoption.Start.Childbirth">
                    Recent childbirth
                  </Trans>{" "}
                  -
                  {" "}{selectChildBirth === "Yes" ? (
                    <Trans i18nKey="findcareoption.Yes">Yes</Trans>
                  ) : (
                    <Trans i18nKey="findcareoption.No">No</Trans>
                  )}
                </li>
              )}

              {state.IsValidUser && policyNumber && (
                <li>
                  {" "}
                  <Trans i18nKey="findcareoption.Start.Policy">
                    Policy #
                  </Trans>: {policyNumber.trim()}
                </li>
              )}
              {state.IsValidUser && travelDatesFrom && travelDatesTo && (
                <li>
                  <Trans i18nKey="findcareoption.Start.Traveldates">
                    Travel Dates
                  </Trans>
                  : {travelDatesFrom.trim()}
                  {" "}<Trans i18nKey="findcareoption.Start.Dateto">
                    to
                  </Trans>{" "}
                  {travelDatesTo.trim()}
                </li>
              )}
            </ul>
          </div>
          <div className="standby-page-navigation standby-page-navigation-align-bottom">
            <button
              type="button"
              className="button standby-button standby-button-gradient standby-button-gradient-green"
              onClick={() => {
                setState({
                  isLoading_ConfirmDetails:true,
                })
                actions.createTriageSession({
                  hasCurrentLocation,
                  nextStepName,
                  history,
                  setState,
                });
                gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
              }}
            >
              <Trans i18nKey="findcareoption.confirm.confirm">Confirm</Trans>
            </button>
            <Link
              className="standby-button-back"
              to={`/find-care-options/${previousStepName}`}
            >
              <div className="icon">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 1024 1024"
                >
                  <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
                </svg>
              </div>
              <Trans i18nKey="findcareoption.confirm.Edit_info">Edit info</Trans>
            </Link>
          </div>
        </article>

      </LoadingScreen> </div>
  )
};
